import Combine from "../../components/Combine/Combine";
import OurBlog from "./OurBlog";

const Blog = () => {
  return (
    <Combine>
      <OurBlog />
    </Combine>
  );
};

export default Blog;
